module.exports = __webpack_public_path__ + "src/shared-components/icons/checkbox-selected.d41749b4f9b0205a27452c3d9224e0a3.svg";